import { useRouter } from 'next/router'
import { parse } from 'qs'
import { useMemo } from 'react'
import { z } from 'zod'
import { QUERY_PARAMS_PARSE_DEPTH } from '@reward-platform/ancillaries-schemas/common/query-params'

/**
 * @deprecated Use useZodValidatedQueryParams instead for type-safe query parsing and validation.
 */
export function useQueryParams<TQueryParams>() {
  const { query, asPath } = useRouter()
  const queryString = asPath.slice(asPath.indexOf('?') + 1)
  const formattedQuery = useMemo<TQueryParams>(() => {
    const parsed = parse(query as Record<string, string>, { depth: QUERY_PARAMS_PARSE_DEPTH })
    return parsed as unknown as TQueryParams
  }, [query])

  return {
    queryString,
    query: formattedQuery,
  }
}

export function useZodValidatedQueryParams<TSchema extends z.ZodType>(schema: TSchema) {
  const { query, asPath } = useRouter()
  const queryIndex = asPath.indexOf('?')
  const queryString = queryIndex === -1 ? '' : asPath.slice(queryIndex + 1)

  const formattedQuery = useMemo<z.output<TSchema>>(() => {
    const parsed = parse(query as Record<string, string>, { depth: QUERY_PARAMS_PARSE_DEPTH })
    try {
      return schema.parse(parsed)
    } catch (e) {
      throw new Error(`Query params validation failed: ${e}`)
    }
  }, [query, schema])

  return {
    queryString,
    query: formattedQuery,
  }
}
